import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheetManager, ThemeProvider } from "styled-components";
import { shouldForwardProp } from "@com.mgmtp.a12.widgets/widgets-core/lib/common/main/should-forward-prop";
import { colors } from "./colors";
import { applyModulFComponentsConfigs } from "./components";
import { applyModulFSpacing } from "./spacing";
import { applyModulFStyles } from "./styles";
import { typography } from "./typography";
export * from "./types";
const GLOBAL_THEME_CACHE = {};
export const ModulFThemeProvider = function ModulFThemeProvider({ compact, children }) {
    const type = compact ? "compact" : "normal";
    if (!GLOBAL_THEME_CACHE[type]) {
        GLOBAL_THEME_CACHE[type] = applyModulFComponentsConfigs(applyModulFStyles(applyModulFSpacing({ compact, colors, typography })));
    }
    return (_jsx(StyleSheetManager, { shouldForwardProp: shouldForwardProp, children: _jsx(ThemeProvider, { theme: GLOBAL_THEME_CACHE[type], children: children }) }));
};
